"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateVisualizationQuerySchema = void 0;
const zod_1 = require("zod");
const breakdown_1 = require("../breakdown");
const comparison_1 = require("../comparison");
const condition_1 = require("../condition");
const granularity_1 = require("../granularity");
const period_1 = require("../period");
exports.CreateVisualizationQuerySchema = zod_1.z.object({
    granularity: granularity_1.TimeGranularitySchema.nullable().optional(),
    breakdown: zod_1.z.array(breakdown_1.AnyBreakdownSchema).nullable().optional(),
    period: period_1.AnyPeriodSchema.nullable().optional(),
    filter: condition_1.AnyConditionExprSchema.nullable().optional(),
    comparison: comparison_1.ComparisonSchema.nullable().optional(),
});
//# sourceMappingURL=querySchema.js.map